<div class="flex flex-col gap-2">
  <div class="flex items-center justify-center gap-2">
    <p-button
      label="Dismiss"
      type="button"
      (click)="deleteInvitation()"
      [loading]="loading()"
      severity="secondary"
      size="small"
    >
    </p-button>
    <p-button
      label="Join"
      type="button"
      (click)="acceptInvitation()"
      [loading]="loading()"
      [icon]="PrimeIcons.USER_PLUS"
      size="small"
    >
    </p-button>
  </div>
  <lib-response-error-box [responseError]="responseError()" />
</div>
